export default {
  title: 'Material Library',
  tabImage: 'Images',
  tabVideo: 'Videos',
  allGroups: 'All Groups',
  addGroup: 'Add Group',
  editGroup: 'Edit Group',
  deleteGroup: 'Delete Group',
  groupName: 'Group Name',
  groupNamePlaceholder: 'Enter group name',
  confirmDeleteGroup:
    'Are you sure you want to delete this group? Materials in this group will be moved to Ungrouped.',
  upload: 'Upload Image',
  uploadVideo: 'Upload Video',
  batchGroup: 'Batch Group',
  batchDelete: 'Batch Delete',
  searchName: 'Image Name',
  searchNamePlaceholder: 'Enter name',
  selected: 'Selected',
  item: 'item(s)',
  cancelSelect: 'Cancel',
  preview: 'Preview',
  copyLink: 'Copy Link',
  confirmDelete: 'Are you sure you want to delete the selected materials?',
  confirmDeleteSingle: 'Are you sure you want to delete this material?',
  copySuccess: 'Link copied',
  moveSuccess: 'Moved successfully',
  uploadSuccess: 'Uploaded successfully',
  uploadTitle: 'Upload Material',
  dragTip: 'Click or drag files to this area to upload',
  uploadLimit: 'Supports JPG, PNG, GIF format, max 5MB per file',
  uploadVideoLimit: 'Supports MP4, AVI format, max 500MB per file',
  editTitle: 'Edit Material',
  materialName: 'Material Name',
  materialNamePlaceholder: 'Enter material name',
  moveGroupTitle: 'Move to Group',
  targetGroup: 'Target Group',
  selectGroupPlaceholder: 'Select group',
  ungrouped: 'Ungrouped',
  emptyImage: 'No images yet',
  emptyVideo: 'No videos yet',
  uploadNow: 'Upload Now',
  videoCover: 'Video Cover',
  uploadCover: 'Upload Cover',
  uploadFile: 'Upload File',
  uploadFileRequired: 'Please select a file to upload',
  videoCoverRequired: 'Please upload video cover',
  fileSizeExceed: 'File size exceeds {max}',
};
